import { LandingCtaLink } from '@/landing/landing-cta-link'
import { getSignupLegalConfig, type SignupLegalConfig } from '@/constants/signup'

const linkClassName =
  'font-medium text-foreground underline-offset-4 hover:underline'

function TermsPrivacyLinks({
  legal,
  separator,
}: {
  legal: SignupLegalConfig
  separator: 'and' | 'dot'
}) {
  const termsLink = (
    <LandingCtaLink to={legal.termsUrl} className={linkClassName}>
      {legal.termsLabel ?? 'Terms of Service'}
    </LandingCtaLink>
  )
  const privacyLink = (
    <LandingCtaLink to={legal.privacyUrl} className={linkClassName}>
      {legal.privacyLabel ?? 'Privacy Policy'}
    </LandingCtaLink>
  )

  if (separator === 'and') {
    return (
      <>
        {termsLink} and {privacyLink}
      </>
    )
  }

  return (
    <>
      {termsLink} · {privacyLink}
    </>
  )
}

/** Terms and Privacy links only — for sign-in and other non-registration auth screens. */
export function AuthLegalLinks({
  legal = getSignupLegalConfig(),
}: {
  legal?: SignupLegalConfig | null
} = {}) {
  if (!legal) return null

  return (
    <p className="text-center text-xs text-muted-foreground">
      <TermsPrivacyLinks legal={legal} separator="dot" />
    </p>
  )
}

/** Registration consent line with Terms and Privacy links. */
export function SignupLegalNotice({
  legal = getSignupLegalConfig(),
}: {
  legal?: SignupLegalConfig | null
} = {}) {
  if (!legal) return null

  return (
    <p className="text-center text-xs text-muted-foreground">
      By joining, you agree to our <TermsPrivacyLinks legal={legal} separator="and" />.
    </p>
  )
}
